import * as React from 'react'
import MUIMenuItem from '@mui/material/MenuItem'

const MenuItem = (props) => <MUIMenuItem {...props} />

export default MenuItem
